import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import './Blog.css'; // I will create this file

const BlogHome = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog`);
                setPosts(response.data);
            } catch (error) {
                console.error('Erro ao buscar posts do blog:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPosts();
    }, []);

    if (loading) {
        return (
            <div className="container" style={{ textAlign: 'center', padding: '100px' }}>
                <div className="loader">Carregando blog...</div>
            </div>
        );
    }

    return (
        <div className="blog-home-container">
            <Helmet>
                <title>Blog Ofertiz - Dicas de Economia e Ofertas</title>
                <meta name="description" content="Fique por dentro das melhores dicas de economia, guias de compra e novidades do mundo das promoções." />
            </Helmet>

            <header className="blog-header">
                <div className="container">
                    <nav className="breadcrumbs">
                        <Link to="/">Início</Link> &gt; <span>Blog</span>
                    </nav>
                    <h1>Blog Ofertiz</h1>
                    <p>Dicas para você economizar de verdade</p>
                </div>
            </header>

            <main className="container">
                <div className="blog-grid">
                    {posts.length > 0 ? (
                        posts.map(post => (
                            <article key={post.id} className="blog-card">
                                <Link to={`/blog/${post.slug}`} className="blog-card-image">
                                    <img src={post.featuredImage} alt={post.title} />
                                </Link>
                                <div className="blog-card-content">
                                    <span className="blog-category">{post.category}</span>
                                    <h2>
                                        <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                                    </h2>
                                    <p className="blog-excerpt">
                                        {post.content.replace(/<[^>]*>/g, '').substring(0, 120)}...
                                    </p>
                                    <div className="blog-card-footer">
                                        <span className="blog-date">
                                            {new Date(post.createdAt).toLocaleDateString('pt-BR')}
                                        </span>
                                        <Link to={`/blog/${post.slug}`} className="read-more">
                                            Ler mais <i className="fas fa-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </article>
                        ))
                    ) : (
                        <div className="no-posts">
                            <p>Nenhum artigo publicado ainda. Volte em breve!</p>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default BlogHome;
